import React, { useState, useEffect } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import HeaderComponent from '../../components/HeaderComponent/HeaderComponent';
import NavbarManageComponent from '../../components/NavbarComponent/NavbarManageComponent';
import DashboardComponent from '../../components/DashboardComponent/DashboardComponent';
import BanDoComponent from '../../components/BanDoComponent/BanDoComponent';
import TaoTaiKhoanComponent from '../../components/TaoTaiKhoanComponent/TaoTaiKhoanComponent';
import ThemBKSComponent from '../../components/ThemBKSComponent/ThemBKSComponent';
import MaCXThieuComponent from '../../components/MaCXThieuComponent/MaCXThieuComponent';
import SaiKMDauCuoiComponent from '../../components/SaiKMDauCuoiComponent/SaiKMDauCuoiComponent';
import SaiTrongLuongComponent from '../../components/SaiTrongLuongComponent/SaiTrongLuongComponent';
import HTDTComponent from '../../components/HTDTComponent/HTDTComponent';
import ThongTinHTDTComponent from '../../components/ThongTinHTDTComponent/ThongTinHTDTComponent';
import TimTheoBKSComponent from '../../components/TimTheoBKSComponent/TimTheoBKSComponent';
import LoTrinhNhapComponent from '../../components/LoTrinhNhapComponent/LoTrinhNhapComponent';
import TaoDonKinhDoanhComponent from '../../components/TaoDonKinhDoanhComponent/TaoDonKinhDoanhComponent';
import GanChuyenKinhDoanhComponent from '../../components/GanChuyenKinhDoanhComponent/GanChuyenKinhDoanhComponent';
import BaoCaoDoanhThuKDComponent from '../../components/BaoCaoDoanhThuKDComponent/BaoCaoDoanhThuKDComponent';
import TrangThaiChuyenKDComponent from '../../components/TrangThaiChuyenKDComponentNew/TrangThaiChuyenKDComponent';
import CameraComponent from '../../components/CameraComponent/CameraComponent';
import ChamCongComponent from '../../components/ChamCongComponent/ChamCongComponent';
import TongHopChuyenKDHoanTatComponent from '../../components/TongHopChuyenKDHoanTatComponent/TongHopChuyenKDHoanTatComponent';
import XemThongTinChamCongComponent from '../../components/XemThongTinChamCongComponent/XemThongTinChamCongComponent';
import TaoKhachHangMoiComponent from '../../components/TaoKhachHangMoiComponent/TaoKhachHangMoiComponent';
import XuatDuLieuChuyenKD from '../../components/XuatDuLieuChuyenKD/XuatDuLieuChuyenKD';
import XeKinhDoanhComponent from '../../components/XeKinhDoanhComponent/XeKinhDoanhComponent';
import ChatManagerComponent from '../../components/ChatManagerComponent/ChatManagerComponent';

import DashboardBdScComponent from '../../components/DashboardBaoduongSuachuaComponent/Dashboard';
import ThongKeBdSc from '../../components/DashboardBaoduongSuachuaComponent/ThongKeBdSc';
import BaoCaoTinhTrang from '../../components/DashboardBaoduongSuachuaComponent/baoCaoTinhTrang';
import LichSuBdSc from '../../components/DashboardBaoduongSuachuaComponent/lichSuBdSc';
import SuaChuaBaoDuongComponent from '../../components/DashboardBaoduongSuachuaComponent/SuaChuaBaoDuongComponent';

import TaoDonCongNoComponent from '../../components/CongNoComponent/TaoDonCongNoComponent';
import QuanLyDonCongNoComponent from '../../components/CongNoComponent/QuanLyDonCongNoComponent';
import TaoDonViKinhDoanhComponent from '../../components/DonViKinhDoanhComponent/TaoDonviKinhDoanhComponent';

//Hợp đồng component
import TaoHopDongComponent from '../../components/HopDongComponent/TaoHopDongComponent';

//Quản lý xe
import QuanLyXeComponent from '../../components/QuanLyXeComponent/QuanLyXeComponent';

const ManagerHomePage = ({ setIsLoggedIn }) => {
  const [componentDuocChon, setComponentDuocChon] = useState('dashboard');
  const [isSidebarOpen, setIsSidebarOpen] = useState(window.innerWidth > 768); // Sidebar mặc định đóng trên mobile

  const toggleSidebar = () => {
    setIsSidebarOpen(prev => {
      const newState = !prev;
      //console.log('Trạng thái sidebar sau toggle:', newState);
      return newState;
    });
  };
  
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const renderContent = () => {
    switch (componentDuocChon) {
      case 'dashboard':
        return <DashboardComponent />;
      case 'xeKinhDoanh':
        return <XeKinhDoanhComponent />;
      case 'map':
        return <BanDoComponent />;
      case 'createAccount':
        return <TaoTaiKhoanComponent />;
      case 'loTrinhNhap':
        return <LoTrinhNhapComponent />;
      case 'addVehicle':
        return <ThemBKSComponent />;
      case 'missingTrip':
        return <MaCXThieuComponent />;
      case 'wrongKm':
        return <SaiKMDauCuoiComponent />;
      case 'wrongWeight':
        return <SaiTrongLuongComponent />;
      case 'htdt':
        return <HTDTComponent />;
      case 'viewHtdt':
        return <ThongTinHTDTComponent />;
      case 'timTheoBKS':
        return <TimTheoBKSComponent />;
      case 'taoDonKinhDoanh':
        return <TaoDonKinhDoanhComponent />;
      case 'ganChuyenKinhDoanh':
        return <GanChuyenKinhDoanhComponent />;
      case 'trangThaiChuyenDaTao':
        return <TrangThaiChuyenKDComponent />;
      case 'duLieuKD':
        return <XuatDuLieuChuyenKD />;
      case 'tongHopChuyenKDHoanTat':
        return <TongHopChuyenKDHoanTatComponent />;
      case 'baoCaoDoanhThuKD':
        return <BaoCaoDoanhThuKDComponent />;
      case 'chamCong':
        return <ChamCongComponent />;
      case 'camera':
        return <CameraComponent />;
      case 'xemTTChamCong':
        return <XemThongTinChamCongComponent />;  
      case 'taoKhachHangMoi':
        return <TaoKhachHangMoiComponent />;   
      case 'quanlyCongNo':
        return <QuanLyDonCongNoComponent />;
      case 'taodonCongNo':
        return <TaoDonCongNoComponent />;
      case 'taodvkd':
        return <TaoDonViKinhDoanhComponent/>
      case 'dashboardBaoduongSuachua':
        return <DashboardBdScComponent setComponentDuocChon={setComponentDuocChon} />;     
      case 'thongkebdsc':
        return <ThongKeBdSc setComponentDuocChon={setComponentDuocChon}/>;  
      case 'baoCaoTinhTrang':
        return <BaoCaoTinhTrang setComponentDuocChon={setComponentDuocChon}/>;  
      case 'lichSuBdSc':
        return <LichSuBdSc setComponentDuocChon={setComponentDuocChon}/>;
      case 'baoDuongSuaChua':
        return <SuaChuaBaoDuongComponent setComponentDuocChon={setComponentDuocChon} />;   
      
      case 'taohopdong':
        return <TaoHopDongComponent />;
      case 'quanlyxe':
        return <QuanLyXeComponent />;
        
      case 'tinNhanKhachHang':
        return <ChatManagerComponent />;    
      default:
        return <DashboardComponent />;
    }
  };

  return (
    <div className="d-flex flex-column vh-100">
      {/* Header */}
      <div style={{ height: '80px', position: 'fixed', width: '100%', top: 0, zIndex: 1000 }}>
        <HeaderComponent setIsLoggedIn={setIsLoggedIn} toggleSidebar={toggleSidebar} />
      </div>

      {/* Main Content */}
      <div style={{ display: 'flex', flexGrow: 1, marginTop: '80px' , padding: '0'}}>
        {/* Sidebar cố định */}
        <div
          style={{
            width: isSidebarOpen ? '16.67%' : '0',
            height: 'calc(100vh - 80px)',
            overflow: 'hidden',
            backgroundColor: '#fff',
            borderRight: '1px solid #ccc',
            transition: 'width 0.3s ease',
            zIndex: 999,
            padding: 0,
            margin: 0,
            boxSizing: 'border-box',
          }}
        >
          {isSidebarOpen && (
            <NavbarManageComponent
              setComponentDuocChon={setComponentDuocChon}
              isSidebarOpen={isSidebarOpen}
              toggleSidebar={toggleSidebar}
            />
          )}
        </div>

        {/* Nội dung chính */}
        <div
          style={{
            flexGrow: 1,
            marginLeft: isSidebarOpen ? '4%' : '0',
            transition: 'margin-left 0.3s ease',
            padding: '20px',
            height: 'calc(100vh - 80px)',
            overflowY: 'auto',
            width: '100%',
          }}
        >
          {renderContent()}
        </div>
      </div>
    </div>
  );
};

export default ManagerHomePage;
                                                                                            